// OPS Occult Library comparative visual archive v8 — Amulets source pack.
(()=>{
  const TITLE='amulets';
  const SOURCES=[
    {
      date:'664–525 BCE',
      period:'Ancient Egypt, Late Period, Dynasty 26',
      creator:'Unknown Egyptian maker',
      work:'Wedjat eye amulet',
      page:'The Met object 10.130.1900',
      institution:'The Metropolitan Museum of Art, Egyptian Art',
      collection:'Gift of Helen Miller Gould, 1910; object 10.130.1900',
      imageUrl:'https://collectionapi.metmuseum.org/api/collection/v1/iiif/558320/1370485/main-image',
      sourceUrl:'https://www.metmuseum.org/art/collection/search/558320',
      rights:'Public Domain; The Met Open Access image',
      rightsUrl:'https://www.metmuseum.org/policies/image-resources',
      attribution:'Wedjat eye amulet, Egypt, Late Period, Dynasty 26, 664–525 BCE, faience. The Metropolitan Museum of Art, 10.130.1900. Public Domain / The Met Open Access.',
      medium:'Faience amulet',
      process:'Faience manufacture; exact forming technique is not specified in the museum record',
      material:'Faience',
      dimensions:'L. 3.3 × H. 3.2 cm',
      colour:'Blue-green glazed object; colour museum photograph',
      visual:'A compact eye profile is reduced to thick raised contours and incised linear details; the blue-green surface and suspension form make the symbol read as a wearable object rather than a drawn emblem.',
      note:'The Met identifies the wedjat as a protective and regenerative amulet used by both the living and the dead.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'ca. 2nd–3rd century CE',
      period:'Roman Imperial period',
      creator:'Unknown Roman gem engraver',
      work:'Onyx intaglio: Incantation in Greek letters',
      page:'The Met object 15.43.317',
      institution:'The Metropolitan Museum of Art, Greek and Roman Art',
      collection:'Bequest of Mary Anna Palmer Draper, 1915; object 15.43.317',
      imageUrl:'https://collectionapi.metmuseum.org/api/collection/v1/iiif/249035/544865/main-image',
      sourceUrl:'https://www.metmuseum.org/art/collection/search/249035',
      rights:'Public Domain; The Met Open Access image',
      rightsUrl:'https://www.metmuseum.org/policies/image-resources',
      attribution:'Onyx intaglio: Incantation in Greek letters, Roman, ca. 2nd–3rd century CE. The Metropolitan Museum of Art, 15.43.317. Public Domain / The Met Open Access.',
      medium:'Engraved gemstone amulet',
      process:'Intaglio engraving',
      material:'Onyx',
      dimensions:'H. 2.8 cm',
      colour:'Natural translucent stone; colour museum photograph',
      visual:'The inscription is cut directly into the circular stone in compact horizontal lines, with small star-like marks and a narrow engraved border keeping the writing legible at amulet scale.',
      note:'The Met explicitly describes this object as an amulet with inscriptions on both sides; the catalogue does not assign a more specific protective purpose, so none is invented here.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'15th–early 16th century',
      period:'Late medieval / early modern Islamic South Asia',
      creator:'Unknown maker or workshop',
      work:'Talismanic Shirt',
      page:'The Met object 1998.199',
      institution:'The Metropolitan Museum of Art, Islamic Art',
      collection:'Attributed to Northern India or the Deccan; object 1998.199',
      imageUrl:'https://collectionapi.metmuseum.org/api/collection/v1/iiif/453498/1682846/main-image',
      sourceUrl:'https://www.metmuseum.org/art/collection/search/453498',
      rights:'Public Domain; The Met Open Access image',
      rightsUrl:'https://www.metmuseum.org/policies/image-resources',
      attribution:'Talismanic Shirt, attributed to Northern India or the Deccan, 15th–early 16th century, cotton, ink and gold. The Metropolitan Museum of Art, 1998.199. Public Domain / The Met Open Access.',
      medium:'Painted protective textile',
      process:'Plain-weave cotton, painted',
      material:'Cotton, ink and gold',
      dimensions:'63.5 × 98.4 cm',
      colour:'Colour; orange, blue and gold writing and ruled decoration on pale cotton',
      visual:'Dense sacred text is organised into ruled squares, circular medallions and pointed lower panels; the garment itself becomes the support for a highly ordered field of protective writing.',
      note:'The Met records that the shirt was believed to carry protective power and may have been intended for wear beneath armour.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'17th–19th century',
      period:'Early modern to 19th-century Tibet',
      creator:'Unknown Tibetan metalworker',
      work:'Amulet Case',
      page:'The Met object 15.95.172',
      institution:'The Metropolitan Museum of Art, Asian Art',
      collection:'John Stewart Kennedy Fund, 1915; object 15.95.172',
      imageUrl:'https://collectionapi.metmuseum.org/api/collection/v1/iiif/39472/131855/main-image',
      sourceUrl:'https://www.metmuseum.org/art/collection/search/39472',
      rights:'Public Domain; The Met Open Access image',
      rightsUrl:'https://www.metmuseum.org/policies/image-resources',
      attribution:'Amulet Case, Tibet, 17th–19th century, gold with precious and semi-precious stones. The Metropolitan Museum of Art, 15.95.172. Public Domain / The Met Open Access.',
      medium:'Gold amulet case',
      process:'Metalwork set with precious and semi-precious stones; exact fabrication technique is not specified in the museum record',
      material:'Gold with precious and semi-precious stones',
      dimensions:'15.2 × 14.6 cm',
      colour:'Gold and multicoloured stone; colour museum photograph',
      visual:'A shallow rectangular case is divided into repeated ornamental panels and raised floral stone settings, with turquoise dominating the surface against darkened gold metalwork.',
      note:'This record adds the container itself to the archive: an amulet can be a case designed to hold a protective or sacred substance rather than only the charged object inside it.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'19th century',
      period:'19th-century Ethiopia',
      creator:'Amhara or Tigrinya traditional healer / manuscript maker; individual maker not recorded',
      work:'Healing Scroll',
      page:'The Met object 2017.680.1',
      institution:'The Metropolitan Museum of Art, The Michael C. Rockefeller Wing',
      collection:'Ethiopia; Amhara or Tigrinya peoples; object 2017.680.1',
      imageUrl:'https://collectionapi.metmuseum.org/api/collection/v1/iiif/771515/1763900/main-image',
      sourceUrl:'https://www.metmuseum.org/art/collection/search/771515',
      rights:'Public Domain; The Met Open Access image',
      rightsUrl:'https://www.metmuseum.org/policies/image-resources',
      attribution:'Healing Scroll, Ethiopia, Amhara or Tigrinya peoples, 19th century, parchment and pigments. The Metropolitan Museum of Art, 2017.680.1. Public Domain / The Met Open Access.',
      medium:'Protective manuscript scroll',
      process:'Handwritten and painted scroll combining prayers with talismanic imagery',
      material:'Parchment and pigments',
      dimensions:'169.9 × 11.4 cm',
      colour:'Colour manuscript on parchment',
      visual:'A very narrow vertical strip alternates dense lines of script with framed painted images and geometric talismanic devices; the elongated format reflects an object intended to be carried with a specific person.',
      note:'The Met states that customised Ethiopian protective scrolls were carried on the person they were made for and combined sacred imagery with textual prayers to shield the owner from harm.',
      verifiedOn:'2026-09-13'
    }
  ];

  const key=(value)=>String(value||'').trim().toLowerCase();
  const nudgeRenderer=()=>{
    const target=document.querySelector('[data-library-reader]');
    if(!target) return;
    const marker=document.createComment('ops-visual-archive-v8-ready');
    target.appendChild(marker);
    marker.remove();
  };
  const install=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    const entry=pack.entries.find((item)=>key(item&&item.title)===TITLE);
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    nudgeRenderer();
    return true;
  };
  if(!install()) document.addEventListener('DOMContentLoaded',install,{once:true});
})();
